import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faHandshake, faAward } from '@fortawesome/free-solid-svg-icons';
import './Home.css';

function Home() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home">
      <section className="hero">
        <video autoPlay muted loop className="video-background">
          <source src="/block.mp4" type="video/mp4" />
        </video>
        <div className="overlay"></div>
        <Container>
          <Row className="align-items-center min-vh-100">
            <Col md={6}>
              <div className="hero-content">
                <h1>Descoperă Casa Visurilor Tale</h1>
                <p>Expertiza și profesionalismul nostru, cheia spre noua ta locuință</p>
                {/* <button 
                  onClick={() => scrollToSection('properties')} 
                  className="cta-button"
                >
                  Vezi Proprietățile Noastre
                </button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section className="features">
        <Container>
          <Row>
            <Col md={4}>
              <div className="feature-card">
                <FontAwesomeIcon icon={faHome} className="feature-icon" />
                <h3>Proprietăți Premium</h3>
                <p>Selecție atentă de proprietăți în cele mai căutate zone</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="feature-card">
                <FontAwesomeIcon icon={faHandshake} className="feature-icon" />
                <h3>Servicii Complete</h3>
                <p>Asistență personalizată pe tot parcursul tranzacției</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="feature-card">
                <FontAwesomeIcon icon={faAward} className="feature-icon" />
                <h3>Experiență Dovedită</h3>
                <p>Avem peste 10 ani de excelență în domeniul imobiliar</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
    </div>
  );
}

export default Home;